module.exports = __webpack_public_path__ + "img/FooterCpptBinaumat.149ae0b0.png";